import type { JobStatus } from '~/lib/api';

/**
 * Two different questions about a job's status, which were being asked with three
 * untyped string arrays in three files.
 *
 * They are NOT the same predicate, which is why they are not one list. Polling must keep
 * running while a job is held — that is the whole point of the held state, the app has to
 * see the release — but the screens must not draw a held job as still being worked on,
 * because nothing is computing and a progress track that crawls while a person reads is
 * a lie.
 *
 * Typed as `JobStatus`, not `string`, so a typo or a new member of the union is a compile
 * error rather than a job that silently falls through to the analysing spinner forever.
 */

/** Statuses at which `useJob` stops polling. Deliberately excludes `pending_review`. */
export const POLL_TERMINAL: readonly JobStatus[] = ['complete', 'partial', 'failed'];

/** Statuses at which no machine is working any more. Includes `pending_review`. */
export const MACHINE_DONE: readonly JobStatus[] = [
  'complete',
  'partial',
  'failed',
  'pending_review',
];

/** True while a machine is still working — so a spinner or a progress track is honest. */
export function isRunning(status: JobStatus): boolean {
  return !MACHINE_DONE.includes(status);
}
